import { MutableRefObject } from "react";
import { NavigateFunction } from "react-router-dom";
import { submitFaxFormQuestionaire } from "../../../../api/postCall/submitFaxFormQuestionaire";
import store from "../../../../redux/store/store";
import { getFaxPdfLinkRecursively } from "../../../../utils/getFaxPdfLinkRecursively";

/**
 * Handles post-save navigation for fax-type form submissions.
 *
 * When `skip_medical_necessity` is enabled in the form config, bypasses the
 * procedure questionnaire entirely — submits the fax form directly, starts
 * polling for the generated PDF link, and navigates to the final document page.
 *
 * Otherwise, navigates to the procedure questionnaire for the user to complete.
 *
 * @param id - Medical PA order id
 * @param navigate - React Router navigate function
 * @param intervalRef - Ref holding the fax-PDF poll timeout id
 * @param setIsSubmitting - Loading flag setter for the submit/poll UI
 * @param orgId - Tenant org id for PG PDF-link polling (submit uses auth facility)
 */
export const handleFaxSubmission = async (
  id: string,
  navigate: NavigateFunction,
  intervalRef: MutableRefObject<NodeJS.Timeout | null>,
  setIsSubmitting: (value: boolean) => void,
  orgId?: string | null,
) => {
  const { data: formConfig } = store.getState().singleMedicalPaFormConfig;
  if (formConfig?.skip_medical_necessity === true) {
    const formId = formConfig?.id;
    if (formId) {
      await submitFaxFormQuestionaire({
        form_id: formId,
        order_id: id,
      });
      getFaxPdfLinkRecursively({
        orderId: id ?? "",
        orgId,
        navigate,
        intervalRef,
        setIsSubmitting,
      });
    }
  } else {
    navigate(`/worklists/procedure-questionaire/${id}`);
  }
};
